import 'odometer'

$(() => {
  $(window).on('load scroll', () => {
    if(window.scrollY + window.innerHeight <= $('.footer').offset().top) {
      $('.fixed-link-line, .fixed-entry-button').fadeIn()
    }else {
      $('.fixed-link-line, .fixed-entry-button').fadeOut()
    }
  })

  window.odometerOptions = {
    format: 'd'
  };

  $('.odometer').each(function(index) {
    const meter = this
    const $this = $(this)

    $(window).on(`load.active-odometer-${index} scroll.active-odometer-${index}`, function() {
      if(window.scrollY + window.innerHeight * 0.8 >= $this.offset().top) {
        meter.innerHTML = parseInt($this.data('num'))
        $(window).off(`.active-odometer-${index}`)
      }
    })
  })
})